
import Vue from 'vue'
import updateManOrg from '@/connectors/managing-organization/update-managing-organization'

export default Vue.extend({
  name: 'StartWizard',
  methods: {
    numberOfHouses (quantity) {
      updateManOrg(Number(localStorage.getItem('moid')), { onlyOneHouse: quantity })
        .then(() => {
          localStorage.setItem('onlyOneHouse', quantity)
          this.$router.push('/app/managing_organization_wizard')
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  }
})
